import React from 'react';
import { researchAreas } from '../../constants/types';

const AreasOfExpertise = ({ formData, handleChange }) => {
  const handleCategoryChange = (event, fieldName) => {
    const selectedCategory = event.target.value;
    const categoryEvent = { target: { name: `${fieldName}Category`, value: selectedCategory } };
    handleChange(categoryEvent);
    const topicEvent = { target: { name: fieldName, value: "" } };
    handleChange(topicEvent);
  };

  return (
    <div>
      <h4 className="mb-4">Areas of Expertise</h4>

      {/* Primary 1 */}
      <div className="mb-3">
        <label htmlFor="primary1Category" className="form-label">
          Primary 1 - Category <span className="text-danger">*</span>
        </label>
        <select
          className="form-select"
          id="primary1Category"
          name="primary1Category"
          value={formData.primary1Category || ""}
          onChange={(e) => handleCategoryChange(e, "primary1")}
          required
        >
          <option value="">Select category...</option>
          {Object.keys(researchAreas).map((category, index) => (
            <option key={index} value={category}>{category}</option>
          ))}
        </select>
        {formData.primary1Category && (
          <div className="ms-4 mt-2">
            <label htmlFor="primary1" className="form-label">
              Primary 1 - Topic <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              id="primary1"
              name="primary1"
              value={formData.primary1 || ""}
              onChange={handleChange}
              required
            >
              <option value="">Select topic...</option>
              {researchAreas[formData.primary1Category]?.map((topic, index) => (
                <option key={index} value={topic}>{topic}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Primary 2 */}
      <div className="mb-3">
        <label htmlFor="primary2Category" className="form-label">
          Primary 2 - Category <span className="text-danger">*</span>
        </label>
        <select
          className="form-select"
          id="primary2Category"
          name="primary2Category"
          value={formData.primary2Category || ""}
          onChange={(e) => handleCategoryChange(e, "primary2")}
          required
        >
          <option value="">Select category...</option>
          {Object.keys(researchAreas).map((category, index) => (
            <option key={index} value={category}>{category}</option>
          ))}
        </select>
        {formData.primary2Category && (
          <div className="ms-4 mt-2">
            <label htmlFor="primary2" className="form-label">
              Primary 2 - Topic <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              id="primary2"
              name="primary2"
              value={formData.primary2 || ""}
              onChange={handleChange}
              required
            >
              <option value="">Select topic...</option>
              {researchAreas[formData.primary2Category]?.map((topic, index) => (
                <option key={index} value={topic}>{topic}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Primary 3 */}
      <div className="mb-3">
        <label htmlFor="primary3Category" className="form-label">
          Primary 3 - Category <span className="text-danger">*</span>
        </label>
        <select
          className="form-select"
          id="primary3Category"
          name="primary3Category"
          value={formData.primary3Category || ""}
          onChange={(e) => handleCategoryChange(e, "primary3")}
          required
        >
          <option value="">Select category...</option>
          {Object.keys(researchAreas).map((category, index) => (
            <option key={index} value={category}>{category}</option>
          ))}
        </select>
        {formData.primary3Category && (
          <div className="ms-4 mt-2">
            <label htmlFor="primary3" className="form-label">
              Primary 3 - Topic <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              id="primary3"
              name="primary3"
              value={formData.primary3 || ""}
              onChange={handleChange}
              required
            >
              <option value="">Select topic...</option>
              {researchAreas[formData.primary3Category]?.map((topic, index) => (
                <option key={index} value={topic}>{topic}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="alert alert-info">
        <i className="bi bi-info-circle me-2"></i>
        <small>Please select exactly three primary areas of expertise by first choosing a category and then a specific topic for each.</small>
      </div>
    </div>
  );
};

export default AreasOfExpertise;
